import { useContext } from 'react';
import { UserProviderValue } from '../models';
import { UserContext } from '../contexts/user.context';
import { usePageRestriction } from '../hooks';
import { Account } from '../components';

export function AccountPage() {
   const { isAuthenticated } = useContext<UserProviderValue>(UserContext);
   usePageRestriction('authenticated', '/login', isAuthenticated);

   return <Account />;
}
